import { api } from '../client';
import type { AuthTokens, AuthenticatedUser } from '@/types/domain';

export interface LoginPayload {
  email: string;
  password: string;
}

export interface ChangePasswordPayload {
  currentPassword: string;
  newPassword: string;
}

export const authApi = {
  login: (payload: LoginPayload) => api.post<AuthTokens>('/auth/login', payload),
  logout: (refreshToken: string) => api.post<void>('/auth/logout', { refreshToken }),
  me: () => api.get<AuthenticatedUser>('/auth/me'),
  changePassword: (payload: ChangePasswordPayload) => api.post<void>('/auth/change-password', payload),
};
